import DatePicker from "react-datepicker2";
import { Calender } from "assets/images";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMessageChatFilterMutation } from "redux/RTQ/IlenkradApi";

import lottieJson from "assets/gifs/dottedBtn.json";
import Lottie from "react-lottie-player";
const NotificationFilterPc = ({
  closeDrawer,
  id,
  back,
  getDataChatFilter,
}: any) => {
  
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [optionName, setOptionsName] = useState<string>("");
  const [message_type, setMessage_type] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const openOptions = () => {
    setShowOptions(!showOptions);
  };

  const selectOption = (name: string, enName: string) => {
    setOptionsName(name);
    setMessage_type(enName);
    openOptions();
  };
  const chatId: any = id;
  const [startDate, setStartDate] = useState<any>(null);
  

  const options = [
    { id: 0, name: "دستورات ارسالی", enName: "command" },
    { id: 1, name: "پاسخ دستورات", enName: "command_response" },
    { id: 2, name: "وارد شدن به محدوده", enName: "geo_fence_enter" },
    { id: 3, name: "خارج شدن از محدوده", enName: "geo_fence_exit" },
    { id: 4, name: "هشدارهای ردیاب", enName: "tracker_alert" },
    { id: 5, name: "پیام های کاربر", enName: "user_support" },
    { id: 6, name: "پیام های پشتیبان", enName: "admin_support" },
    { id: 7, name: "پیام های کانال", enName: "channel" },
  ];
  const checkValidationStrings = (value: string) => {
    if (value) {
      return { iserror: false, errorText: "" };
    } else {
      return { iserror: true, errorText: "پر کردن این فیلد اجباری است" };
    }
  };

  const [
    mutateFilter,
    {
      data: dataMessageFilter,
      isLoading: isLoadingMessageFilter,
      isSuccess: isSuccessMessageFilter,
      error: errorMessageFilter,
    },
  ] = useMessageChatFilterMutation();
  const submitFilter = () => {
    const checkMessageType = checkValidationStrings(optionName);
    const checkStartDate = checkValidationStrings(startDate);
    if (!checkMessageType.iserror && !checkStartDate.iserror) {
      const obj = {
        id: chatId,
        message_type,
        from_date_time: new Date(startDate).toISOString(),
      };
      mutateFilter(obj);
    } else {
      setError(true);
    }
  };
  const closeOptions = () => {
    setShowOptions(false);
  };

  useEffect(() => {
    const dataSuccess: any = dataMessageFilter;

    if (isSuccessMessageFilter) {
      getDataChatFilter(dataSuccess);
    }
  }, [isSuccessMessageFilter, errorMessageFilter]);
  return (
    <div onClick={closeOptions} className="filterPage-bg">
      <div className="rowFilterNotification">
        <div onClick={closeDrawer} className="icon3-close pointer" />
        <div className="titleListHeader mt-filterText">فیلتر ها</div>
      </div>
      <div className="rowBodyModalSettingMap mt-filterRow">
        <div
           onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.stopPropagation();
            openOptions();
          }}
          className={
            error && checkValidationStrings(optionName).iserror
              ? "containerInpuSettingsMapValidate"
              : "containerInpuSettingsMap"
          }
        >
          <div className="lableAbsoluteOption">نوع پیام </div>
          <div className="inpTitleSettingMap">{optionName}</div>
          <div className="icon3-chevron-down" />
        </div>
        {showOptions ? (
          <div className="containerOptionsAbsolute paddingTopItemAbsolute scrollbar-div ">
            {options.map((opt: any) => (
              <div
                onClick={() => selectOption(opt.name, opt.enName)}
                key={opt.id}
                className="rowFilterItemNotification pointer"
              >
                <div className="mapTrackersModalItemRow">
                  <div className="mapTrackersModalLabel">{opt.name}</div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <div className="reportFilterTitle paddingTime_notification">
        تاریخ پیام
      </div>
      <div className="reportFilterDateRow widthFilter">
        <div className="reportFilterDateChat">
          <img className="reportCalenderImage" src={Calender} />
          {!startDate ? (
            <div className="reportCalenderTitle">از تاریخ</div>
          ) : null}
          <DatePicker
            timePicker={false}
            isGregorian={false}
            className={
              error && checkValidationStrings(startDate).iserror
                ? "reportFilterDateInputDatePickerValidate"
                : "reportFilterDateInputDatePicker"
            }
            value={startDate}
            onChange={(date) => setStartDate(date)}
          />
        </div>
      </div>
      <div className="profileRowContainerButtons">
        <div onClick={submitFilter} className="BtnAddTrackerSubmit pointer">
          {!isLoadingMessageFilter ? (
            "فیلتر"
          ) : (
            <div className="containerLottieDoted">
              <Lottie
                loop
                animationData={lottieJson}
                play
                className="dotedLottie"
              />
            </div>
          )}
        </div>
        <div onClick={back} className="BtnAddTrackerCancel pointer">
          انصراف
        </div>
      </div>
    </div>
  );
};

export default NotificationFilterPc;
